/** Sort key for a finance document number. The trailing sequence sorts first: on the plain
 *  string the year dominates and AUF-2025-014 lands below AUF-2026-001. */
export function numberSortValue(number) {
    const str = String(number ?? '');
    const match = str.match(/(\d+)\s*$/);
    const sequence = match ? Number(match[1]) : 0;
    return `${String(sequence).padStart(9, '0')}|${str}`;
}

/** The next free order number, continuing the highest existing sequence — the same rule the
 *  backend applies, so the form and a converted offer cannot disagree. */
export function nextOrderNumber(allOrders) {
    const numbers = (allOrders || [])
        .map(o => {
            const m = (o.order_number || '').match(/(\d+)$/);
            return m ? parseInt(m[1], 10) : 0;
        })
        .filter(n => n > 0);
    const next = numbers.length ? Math.max(...numbers) + 1 : 1;
    return `AUF-${new Date().getFullYear()}-${String(next).padStart(3, '0')}`;
}

/** The next free invoice or offer number. Prefix and padding come from the highest existing one,
 *  because each organisation has its own scheme and only `Orders` has a UNIQUE constraint. */
export function nextDocumentNumber(docs, field) {
    const highest = (docs || [])
        .map(d => String(d?.[field] ?? ''))
        .filter(n => /(\d+)\s*$/.test(n))
        .sort((a, b) => numberSortValue(a).localeCompare(numberSortValue(b)))
        .pop();
    if (!highest) return '';
    const m = highest.match(/^(.*?)(\d+)\s*$/);
    return m[1] + String(Number(m[2]) + 1).padStart(m[2].length, '0');
}
